import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertTriangle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-width:1.5px;}.a{stroke-linejoin:round;}.b{stroke-miterlimit:10;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "alert-triangle" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,18.75a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,18.75h0"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "b",
			x1: 12,
			y1: 15.75,
			x2: 12,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M13.621,1.76a1.806,1.806,0,0,0-3.242,0L.906,21.058A1.521,1.521,0,0,0,2.272,23.25H21.728a1.521,1.521,0,0,0,1.366-2.192Z"
		})
	]
});
export default SvgAlertTriangle;
